import { IEnvVars } from 'shared/utils';

const PROD_ENV_VARS: IEnvVars = {
  API_ENDPOINT: 'https://rdr-web-exp-api.aerospace1.honeywellaerospace.com',
  ASDS_ENDPOINT: 'https://ads.honeywellaerospace.com/ads/broadcast/message',
  ASDS_ERROR_ENDPOINT:
    'https://aerospace.honeywellaerospace.com/en/secure/learn/products/weather-radar/rdr-7000/software-configuration',
  ASDS_GET_HELP: 'https://aerospace.honeywellaerospace.com/en/pages/rdr-7k-support',
};

export default PROD_ENV_VARS;